module.exports = __webpack_public_path__ + "done-black-18dp.svg?73faf747617001bd3105fb89036cabaa";